var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTop4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.175 7.875V7.60411C14.175 5.84489 13.1723 4.31706 11.7 3.5421V6.79161H10.6001V3.13325C10.2465 3.04972 9.87983 3 9.5 3C9.12017 3 8.75353 3.04972 8.39993 3.13325V6.79161H7.30003V3.5421C5.82723 4.31706 4.82501 5.84472 4.82501 7.60411V7.875H4V8.95839H15V7.875H14.175Z",
    fill: "#546EDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82501 10.5834C4.82501 11.3429 5.35681 11.9755 6.07226 12.1533C6.70916 14.4342 8.0036 16 9.5 16C10.9964 16 12.2908 14.4342 12.9277 12.1533C13.6432 11.9755 14.175 11.3429 14.175 10.5834V10.0416H4.82501V10.5834Z",
    fill: "#546EDB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop4);
export default __webpack_public_path__ + "static/media/top4.fff44786ac2cec53f98b7e7ee1f154d4.svg";
export { ForwardRef as ReactComponent };